module.exports = __webpack_public_path__ + "static/Gary_Bader_headshot_lores-892101ddcc4f5dcb33ef052778fbf18d.png";